import React from 'react'
import Info from '../components/aboutPage/info/Info'
import Hero from '../components/hero/Hero'

const AboutPage = () => {
  return (
    <>
      <Hero page="about"></Hero>
      <Info />
    </>
  )
}

export default AboutPage
